import useUserEngineOilTestApi from './userApi/useUserEngineOilTestApi';
//TODO: Delete
function useUserApi() {
    const userEngineOilTestApi = useUserEngineOilTestApi();

    return { userEngineOilTestApi };
}

export default useUserApi;
